import { Row, Col, Spin } from "antd";
import React from "react";
import { Outlet } from "react-router-dom";
import "./Auth.scss";
import { LoadingOutlined } from "@ant-design/icons";
import { useAuth } from "contexts/AuthContext";

const Auth: React.FC = () => {
  const { loading } = useAuth();
  return (
    <div className="Auth">
      {loading && (
        <div className="loading-wrap">
          <Spin indicator={<LoadingOutlined className="loading-icon" spin />} />
        </div>
      )}
      <Row>
        <Col lg={12} sm={0}>
          <div className="backgroundCover"></div>
        </Col>
        <Col lg={12} sm={24}>
          <Outlet />
        </Col>
      </Row>
    </div>
  );
};

export default Auth;
